import React from 'react';

function Footer() {
    return (
        <footer>
            <div className='footer_content'>
                <a className='gray' href='https://www.linkedin.com/in/ian-rosas/' target='blank'><i class="fab fa-linkedin"></i> Linkedin</a>
                <a className='gray' href='https://codepen.io/ianncus' target='blank'><i class="fab fa-codepen"></i> CodePen</a>
                <p>By Ian Rosas</p>
            </div>
        </footer>
    )
}

export default Footer;